import PropTypes from 'prop-types';

import React from 'react';

import SpellCheckButton from '../BlockControls/SpellCheckButton';

import Wrapper from './Wrapper';

function EditorHeader(props) {
  return (
    <Wrapper>
      <SpellCheckButton onClick={props.onClickSpellcheck} />
    </Wrapper>
  );
}

EditorHeader.propTypes = {
  onClickSpellcheck: PropTypes.func,
};

export default EditorHeader;
